
import CalSubsDeliveryDates from "../cart-dialog/cal-subs-delivery-dates";
import CalCompleteBouquet from "../cart-dialog/cal-complete-bouquet";
import CalRecipientDetails from "../cart-dialog/cal-recipient-details";
import CalDeliveryWindow from "../cart-dialog/cal-delivery-window";
import CalSub6CardMessage from "../cart-dialog/cal-sub6-card-message";
import CalSubsCollection from "../cart-dialog/cal-subs-collection";
import CalSubsSize from "../cart-dialog/cal-subs-size";
import CalSub6Frequency from "../cart-dialog/cal-sub6-frequency";
import CalCardMessage from "../cart-dialog/cal-card-message";
import CalBasketBanner from "~/components/cart-dialog/cal-basket-banner.vue";
import CalHeaderWithProgress from "~/components/cal-header-with-progress.vue";
import CalVasesAddons from "~/components/cal-vases-addons.vue";
import CalAddToBasketFlow from "../cart-dialog/cal-add-to-basket-flow.vue";
import HelperMixin from "~/mixin/helper-mixin";

import { butter } from "../../plugins/buttercms";

export default {
  name: "cal-sub6month-checkout",
  components: {
    CalSubsDeliveryDates,
    CalCompleteBouquet,
    CalRecipientDetails,
    CalDeliveryWindow,
    CalSub6CardMessage,
    CalSubsCollection,
    CalSubsSize,
    CalSub6Frequency,
    CalCardMessage,
    CalBasketBanner,
    CalHeaderWithProgress,
    CalVasesAddons,
    CalAddToBasketFlow,
  },
  data() {
    return {
      subsData: {},
      workflow: "SUBSCRIPTION",
      isEditFlow: false,
      config: {
        displayAddons: true,
        displayVases: true,
        displayDonation: true,
        displayGreets: false,
        autoSelectGreets: false,
        isSameOrderEligble: false,
        isSubscription: true,
      },
      validationStatus: {
        subsCollectionDisabled: true,
        subsSizeDisabled: true,
        sub6MonthFrequencyDisabled: true,
        recipientDetailsDisabled: true,
        deliveryWindowDisabled: true,
        cardMessageDisabled: true,
      },
    };
  },
    mixins: [HelperMixin],

  created() {
    this.$nuxt.$on("recipientDetailsDisabled", (isDisabled) => {
      this.validationStatus.recipientDetailsDisabled = isDisabled;
    });
    this.$nuxt.$on("deliveryWindowDisabled", (isDisabled) => {
      this.validationStatus.deliveryWindowDisabled = isDisabled;
    });
    this.$nuxt.$on("cardMessageDisabled", (isDisabled) => {
      this.validationStatus.cardMessageDisabled = isDisabled;
    });
    this.$nuxt.$on("subsCollectionDisabled", (isDisabled) => {
      this.validationStatus.subsCollectionDisabled = isDisabled;
    });
    this.$nuxt.$on("subsSizeDisabled", (isDisabled) => {
      this.validationStatus.subsSizeDisabled = isDisabled;
    });
    this.$nuxt.$on("sub6MonthFrequencyDisabled", (isDisabled) => {
      this.validationStatus.sub6MonthFrequencyDisabled = isDisabled;
    });

    this.isEditFlow =
      sessionStorage.getItem("editCartItemId") &&
      sessionStorage.getItem("editCartItemId").length > 0
        ? true
        : false;
  },
  props: {
    showCartDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    subscriptionTimePeriod: {
      type: Number,
      required: true,
      default: 0,
    },
    isLoadAddons: {
      type: Boolean,
      required: true,
    },
    isReLoadRecipientDialog: {
      type: Boolean,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  watch: {
    "validationStatus.recipientDetailsDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.deliveryWindowDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.cardMessageDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.subsCollectionDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.subsSizeDisabled"() {
      this.checkIfValidOrder();
    },
    "validationStatus.sub6MonthFrequencyDisabled"() {
      this.checkIfValidOrder();
    },
  },
  methods: {
    scrollToError(){
      this.scrollToFirstError(this.validationStatus);
    },
    closeCartDialog() {
      this.$emit("closeCartDialog");
    },
    checkIfValidOrder() {
      if (
        !this.validationStatus.recipientDetailsDisabled &&
        !this.validationStatus.deliveryWindowDisabled &&
        !this.validationStatus.cardMessageDisabled &&
        !this.validationStatus.subsCollectionDisabled &&
        !this.validationStatus.subsSizeDisabled &&
        !this.validationStatus.sub6MonthFrequencyDisabled
      ) {
        this.$nuxt.$emit("disableContinue", false);
      } else {
        this.$nuxt.$emit("disableContinue", true);
      }
    },
  },
  computed: {
    subscriptionPeriod() {
      return 6;
    },
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "*",
        "subscription-dialog",
        {
          locale: this.$i18n.getLocaleCookie(),
          timeout: 10000,
        }
      );
      this.subsData = page?.data.data.fields;
    } catch (error) {
      console.error(error);
    }
  },
};
